import { useEffect, useState } from "react";
import { loadConfig } from "../../services/Config";

interface Props {
  children: JSX.Element;
  loading: JSX.Element;
  onLoad?(): void;
}

function ConfigProvider(props: Props) {
  const [loaded, setLoaded] = useState<boolean>(false);

  const { children, loading, onLoad } = props;
  const isDev = process.env.NODE_ENV === "development";

  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname) {
      fetch("/conf/config.json")
        .then((response) => {
          return response.json();
        })
        .then((content: string) => {
          loadConfig(content);
          setLoaded(true);
          onLoad && onLoad();
        })
        .catch((error) => {
          console.log("erreur : ", error);
        });
    }
  }, []);

  if (loaded) {
    return children;
  }
  return null;
}

export default ConfigProvider;
